/* Hameldown contact v4: progressive enhancement, no network requests or storage. */
(() => {
  'use strict';
  if (!('customElements' in window) || customElements.get('hameldown-contact')) return;
  const help = Object.freeze({
    advice: 'Tell us what you are looking for and the detail you would like to check. A product name or link is useful.',
    delivery: 'Tell us which item or parcel you are asking about. Items from different brands can arrive separately.',
    returns: 'Tell us which item you wish to return or cancel. You do not need to give a reason to use your cancellation right, or wait for approval to notify us.',
    issue: 'Tell us what has happened and which item is affected. If photographs would help, we will explain how to share them by email.',
    brand: 'Introduce your business, what makes your range distinctive, and whether you supply through Shopify Collective.',
    other: 'Tell us a little about your question and what would be helpful.'
  });
  class HameldownContact extends HTMLElement {
    connectedCallback() {
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const radios = [...this.querySelectorAll('[data-hc-topic]')];
      const refresh = () => {
        const selected = radios.find(radio => radio.checked)?.dataset.hcTopic || '';
        this.querySelectorAll('[data-hc-context]').forEach(group => {
          const show = group.dataset.hcContext.split(/\s+/).includes(selected);
          group.hidden = !show;
          group.querySelectorAll('input, select, textarea').forEach(field => { field.disabled = !show; });
        });
        const note = this.querySelector('[data-hc-help]');
        if (note) note.textContent = help[selected] || help.other;
      };
      this.addEventListener('change', event => { if (event.target.matches('[data-hc-topic]')) refresh(); }, options);
      this.addEventListener('reset', () => { window.setTimeout(refresh, 0); }, options);
      // Only a recognised topic can be selected from the URL. No personal data is read from it.
      try {
        const topic = new URL(window.location.href).searchParams.get('topic');
        if (!radios.some(radio => radio.checked) && Object.prototype.hasOwnProperty.call(help, topic)) {
          const match = radios.find(radio => radio.dataset.hcTopic === topic);
          if (match) match.checked = true;
        }
      } catch (_) { /* The default form remains usable. */ }
      refresh();
      const status = this.querySelector('[data-hc-status]');
      if (status) window.requestAnimationFrame(() => { if (status.isConnected) status.focus({preventScroll:false}); });
      // Do not intercept submit, simulate success, disable Shopify's CAPTCHA,
      // rewrite the action, or send a separate fetch request. Shopify owns submission.
    }
    disconnectedCallback() { window.cancelAnimationFrame(this.frame); this.controller?.abort(); }
  }
  customElements.define('hameldown-contact', HameldownContact);
})();
